import { RevIconButton, RevInput } from "@revmatics/catalyst";
import {
  faTrash,
  faPlus,
  faCheckCircle,
} from "@fortawesome/pro-light-svg-icons";
import { UsernameItem } from "../../../../../../../../../stores/types/brandSocialHandlesTypes.tsx";
import { useState } from "react";

type Props = {
  trashDisplay: boolean;
  plusDisplay: boolean;
  username: UsernameItem;
  handleRemove: () => void;
  handleAdd: () => void;
  handleToValidate: (value: string) => void;
};

export const PlatformInputWrapper = ({
  username,
  trashDisplay,
  plusDisplay,
  handleRemove,
  handleAdd,
  handleToValidate,
}: Props) => {
  const [value, setValue] = useState<string>(username.username || "");

  return (
    <div className={`grid grid-cols-[1fr_88px] gap-2`}>
      <div className={`grid gap-2 grid-cols-1`}>
        <RevInput
          name="username"
          type="text"
          label="Username"
          size="md"
          prependText="@"
          value={value}
          onChange={(event) => setValue(event.target.value)}
          onBlur={() => handleToValidate(value)}
          onClear={() => {
            setValue("");
            handleToValidate("");
          }}
          enableClearButton={username.mode === "new"}
          isLoading={username.status === "loading"}
          iconRight={
            username.status === "valid" && username.mode !== "existing"
              ? faCheckCircle
              : undefined
          }
          success={username.status === "valid" && username.mode !== "existing"}
          error={username.status === "failed" ? "Username doesn't exist" : ""}
          wrapperClassName={`!shadow-none ${
            username.status === "valid" && username.mode !== "existing"
              ? "!border-monochrome-200"
              : ""
          }`}
        />
      </div>
      <div className="flex gap-2 items-start mt-[22px]">
        {trashDisplay && (
          <RevIconButton
            icon={faTrash}
            size="xl"
            iconSize="small"
            handleClick={handleRemove}
          />
        )}
        {plusDisplay && (
          <RevIconButton
            icon={faPlus}
            size="xl"
            iconSize="small"
            handleClick={handleAdd}
          />
        )}
      </div>
    </div>
  );
};
